import script from "./AudioTest.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioTest.vue?vue&type=script&setup=true&lang=ts"

import "./AudioTest.vue?vue&type=style&index=0&id=61a4e4a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61a4e4a0"]])

export default __exports__